import React from 'react';

// Tertiary CTA. No border. Small-caps Bone Dim type with optional trailing
// arrow glyph (→ in Aurum on hover). DESIGN.md §6.1 GhostButton.
const GhostButton = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  trailingIcon,
  className = '',
  ariaLabel,
  'data-testid': testId,
}) => {
  const base = [
    'inline-flex items-center gap-2',
    'font-display uppercase tracking-[0.10em] text-xs',
    'bg-transparent border-0 p-2',
    'transition-colors duration-200 ease-mogged select-none',
    disabled
      ? 'text-vein-dim cursor-not-allowed'
      : 'text-bone-dim hover:text-bone group',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      className={base}
    >
      <span>{children}</span>
      {trailingIcon && (
        <span className="inline-flex items-center text-bone-dim group-hover:text-aurum transition-colors">
          {trailingIcon}
        </span>
      )}
    </button>
  );
};

export default GhostButton;
